module.exports = __webpack_public_path__ + "static/img/bonus_3.a2186df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/bonus_3.png
// module id = GRzo
// module chunks = 0